import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryRefetchInterval } from '@cast/shared-types';
import { SecurityInsightsClusterSecuritySettings } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

import { getSecurityClustersSettingsQueryKey } from './useSecurityClustersSettings';

type UseSingleClusterSettingsQueryArgs = {
  clusterId: string;
  refetchInterval?: QueryRefetchInterval<
    SecurityInsightsClusterSecuritySettings | undefined
  >;
  enabled?: boolean;
  retry?: (failureCount: number, error: unknown) => boolean;
};

const getSingleClusterSettingsQueryOptions = ({
  clusterId,
  refetchInterval,
  retry,
  enabled = true,
}: UseSingleClusterSettingsQueryArgs) =>
  queryOptions({
    queryKey: getSecurityClustersSettingsQueryKey(clusterId),
    queryFn: async () => {
      const { data } =
        await apiClient.securityInsights.getSingleClusterSettings({
          id: clusterId,
        });
      return data.settings;
    },
    enabled: enabled && !!clusterId,
    refetchInterval,
    retry,
  });

export const useSingleClusterSettingsQuery = (
  params: UseSingleClusterSettingsQueryArgs
) => {
  const {
    data: settings,
    isLoading,
    error,
    refetch,
  } = useQuery(getSingleClusterSettingsQueryOptions(params));
  return { settings, isLoading, error, refetch };
};
